module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "7",
      "cy": "7",
      "r": "7",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.4588 4.90249L10.1718 5.17862L10.4588 4.90249C10.2071 4.64075 9.78817 4.64075 9.53638 4.90249L6.19034 8.3808L4.46155 6.61072C4.20912 6.35226 3.79293 6.35384 3.54246 6.6142L3.37278 6.79059C3.13336 7.03947 3.13457 7.43341 3.37552 7.68081L5.73297 10.1014C5.98528 10.3605 6.40198 10.3592 6.65269 10.0986L10.6282 5.96594C10.8666 5.71816 10.8666 5.32633 10.6282 5.07855L10.4588 4.90249Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "0.8"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03edf48f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03edf48f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/icons/DoneIcon.vue
// module id = 677
// module chunks = 0